import Swiper from 'swiper/bundle';

import isMobile from './helpers/mobile'


const build = () => {

    if (isMobile()) {
        setSwiper();
    }

}



const setSwiper = e => {
    let swiper = new Swiper('.injustice .swiper', {
        loop: false,
        speed: 600,
        slidesPerView: 1,

        scrollbar: {
            el: '.swiper-scrollbar',
            dragSize: 30,

        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                freeMode: true,
            },

        },
    })

    swiper.on('slideChangeTransitionEnd', function() {
        adjustScroll();
    })
    swiper.on('sliderMove', function(event) {
        adjustScroll();
    });

    swiper.on('transitionEnd', function(event) {
        adjustScroll();
    });
    swiper.on('transitionStart', function(event) {
        adjustScroll();
    });


}

const adjustScroll = e => {
    var x = $('.swiper-scrollbar-drag').css('transform');
    x = x.replace('matrix(1, 0, 0, 1,', '');
    x = x.replace(', 0)', '');
    x = x + 'px';

    $('.injustice .swiper-scrollbar-progress').css('left', 'calc(' + x + ' - 100vw)');
}

export default () => {
    build()
}